import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Card, Chip, ContentCard, HeaderCard, Icon, Status, Tooltip } from '@weezevent/nacre';
import { colors } from '../../../../../../constants/moderation';

import Style from '../../moderationProfile.module.css';

export default function ModerationProfileSameRequester({ attendee, prefix, order, loading }) {
    const { t } = useTranslation();

    const orderAttendees = React.useMemo(() => {
        if (loading || !order?.attendees?.length) {
            return [];
        }
        return order.attendees?.filter(att => att.id !== attendee.id);
    }, [attendee, loading, order]);

    if (loading || !orderAttendees.length) {
        return null;
    }

    return (
        <Card className={Style['attendee-card']}>
            <HeaderCard>
                <p>{t('ticket.moderation.attendee.sameRequesterTitle')}</p>
            </HeaderCard>
            {orderAttendees.map(attendee => (
                <OtherAttendee key={attendee.id} attendee={attendee} prefix={prefix} />
            ))}
        </Card>
    );
}

const OtherAttendee = ({ prefix, attendee }) => {
    const history = useHistory();
    const { attendee_first_name, attendee_last_name, id_weez_ticket } = attendee;

    return (
        <ContentCard key={attendee.id} className={Style['attendee-sameRequester-container']} onClick={() => history.push(`${prefix}/${attendee.id}`)}>
            <div className={Style['attendee-sameRequester-chipContainer']}>
                <Chip className={Style['attendee-sameRequester-chip']} icon="user" primary />
                <div>
                    <span>
                        {attendee_last_name} {attendee_first_name}
                    </span>
                    <span>{id_weez_ticket}</span>
                </div>
            </div>
            <div>
                <Tooltip title={attendee.status?.name} triggerOnHover>
                    <Status color={colors[attendee.status?.stage]} />
                </Tooltip>
                <Icon name="chevron-right" />
            </div>
        </ContentCard>
    );
};
